import { render } from "./SubViewMain.vue?vue&type=template&id=72df8cf8&scoped=true"
import script from "./SubViewMain.vue?vue&type=script&lang=js"
export * from "./SubViewMain.vue?vue&type=script&lang=js"

import "./SubViewMain.vue?vue&type=style&index=0&id=72df8cf8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72df8cf8"]])

export default __exports__